import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SvgIcon, Typography } from "@mui/material";
import { CoreButton } from "@verity/components/core";
import { isAdmin } from "../../shared";
import { PortalControllerContext } from "../../context";
import { getLmsName } from "../../../helpers/lms-name";
import PortalBanner from "../portal-banner";
import styles from "./index.module.css";
import Megaphone from "../../../images/portal/megaphone.svg?react";

export default function VisualizerBanner() {
	const { dismissUiElement, openQuickSetupGuide, portalContext, userPrivileges, dismissableUiElements } =
		useContext(PortalControllerContext);
	const { lms } = portalContext;
	const { i18n } = useTranslation();
	const shouldRenderBanner = dismissableUiElements.has("visualizerBanner") && isAdmin(userPrivileges, portalContext);
	const lmsName = getLmsName(lms);

	if (!shouldRenderBanner) return null;

	return (
		<div className={styles.portalBannerWrapper}>
			<PortalBanner onClose={() => dismissUiElement("visualizerBanner")}>
				<span className={styles.portalBannerContent}>
					<div className={styles.portalBannerBody}>
						<SvgIcon className={styles.portalInfoIcon}>
							<Megaphone />
						</SvgIcon>
						<Typography fontSize="14px" className={styles.portalBannerText}>
							{i18n.t("portal.components.visualizerBannerTSX.installIntegration", { lms: lmsName })}
						</Typography>
					</div>
					<div className={styles.portalBannerButton}>
						<CoreButton
							component="a"
							style={{ minWidth: "fit-content" }}
							onClick={() => {
								openQuickSetupGuide(true);
								dismissUiElement("visualizerBanner");
							}}
						>
							{i18n.t("portal.components.visualizerBannerTSX.viewIntegrationButton")}
						</CoreButton>
					</div>
				</span>
			</PortalBanner>
		</div>
	);
}
